const { AWP_DEPLOY_ENV = 'local' } = process.env;

const isProd = AWP_DEPLOY_ENV === 'production';

const isStaging = AWP_DEPLOY_ENV === 'staging';

const isLocal = AWP_DEPLOY_ENV === 'local';

// eslint-disable-next-line no-nested-ternary
const baseURL = isProd ? 'https://pc-api.mtcharge.jp' : (isStaging ? 'https://pc-api.mtcharge.jp' : 'https://test-enter-api.mtcharge.jp');

const billBaseURL = isProd ? 'https://settle-api.mtcharge.jp' : 'https://test-settle-api.mtcharge.jp';

export default {
    AWP_DEPLOY_ENV,
    isProd,
    isStaging,
    isLocal,
    baseURL,
    billBaseURL,
};
